import { render, staticRenderFns } from "./climbers.vue?vue&type=template&id=519d0334"
import script from "./climbers.vue?vue&type=script&lang=js"
export * from "./climbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports